const VARIABLE_REGEX = /\{\{\s*([^}]+)\s*\}\}/g;

export const parseTemplateComponent = (componentValue) => {
  if (!componentValue) return null;
  if (typeof componentValue === "object") return componentValue;
  try {
    return JSON.parse(componentValue);
  } catch (error) {
    return null;
  }
};

const extractVariablesFromText = (text = "") => {
  return Array.from(text.matchAll(VARIABLE_REGEX), (match) => String(match[1]).trim()).filter(Boolean);
};

export const substituteVariables = (text = "", values = {}, usePlaceholders = false) => {
  if (!text) return "";
  return text.replace(VARIABLE_REGEX, (match, variableName) => {
    const key = variableName.trim();
    if (values[key] !== undefined && values[key] !== "") {
      return values[key];
    }
    return usePlaceholders ? `[${key}]` : match;
  });
};

export const getTemplateDefinition = (template) => {
  const header = parseTemplateComponent(template?.components?.HEADER);
  const body = parseTemplateComponent(template?.components?.BODY);

  const headerFormat = String(header?.format || "").toLowerCase();
  const headerVariables = headerFormat === "text" ? extractVariablesFromText(header?.text || template?.headerText || "") : [];
  const bodyVariables = extractVariablesFromText(body?.text || template?.body || "");

  return {
    headerFormat,
    headerVariables,
    bodyVariables,
    needsHeaderMediaLink: ["image", "video", "document"].includes(headerFormat),
  };
};

export const buildTemplateComponentsPayload = ({
  template,
  headerValues = {},
  bodyValues = {},
  buttonValues = {},
  codeValue = "",
  isAuthCopyCode = false,
  headerMediaLink = "",
  headerMediaId = "",
  buttonVariables = [],
}) => {
  const { headerFormat, headerVariables, bodyVariables, needsHeaderMediaLink } = getTemplateDefinition(template);
  const components = [];

  if (needsHeaderMediaLink) {
    components.push({
      type: "header",
      parameters: [
        {
          type: headerFormat,
          [headerFormat]: headerMediaLink ? { link: headerMediaLink.trim() } : { id: headerMediaId },
        },
      ],
    });
  } else if (headerFormat === "text" && headerVariables.length > 0) {
    components.push({
      type: "header",
      parameters: headerVariables.map((variableName) => ({
        type: "text",
        parameter_name: variableName,
        text: headerValues[variableName] || "",
      })),
    });
  }

  if (bodyVariables.length > 0) {
    components.push({
      type: "body",
      parameters: bodyVariables.map((variableName) => ({
        type: "text",
        parameter_name: variableName,
        text: bodyValues[variableName] || "",
      })),
    });
  }

  switch (true) {
    case Boolean(isAuthCopyCode && codeValue):
      components.push({
        type: "button",
        sub_type: "url",
        index: "0",
        parameters: [
          {
            type: "text",
            text: codeValue
          }
        ]
      });
      break;

    case Boolean(buttonVariables && buttonVariables.length > 0): {
      const buttonMap = {};
      buttonVariables.forEach(v => {
        if (!buttonMap[v.buttonIndex]) {
          buttonMap[v.buttonIndex] = [];
        }
        buttonMap[v.buttonIndex].push({
          paramIndex: v.paramIndex,
          text: buttonValues[v.key] || ""
        });
      });

      Object.keys(buttonMap).forEach(btnIndex => {
        const params = buttonMap[btnIndex].sort((a, b) => a.paramIndex - b.paramIndex);
        components.push({
          type: "button",
          sub_type: "url",
          index: String(parseInt(btnIndex) - 1),
          parameters: params.map(p => ({
            type: "text",
            text: p.text
          }))
        });
      });
      break;
    }
  }

  return components;
};

